<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" id="surveyViewer" class="bg-light">

  <div *ngIf="!auth.isLoggedIn() && survey.mustBeLoggedIn" class="text-center pt-5">
    <h4>You not are logged in.</h4>
    <p>Please login or create an account to complete this survey.</p>
    <button type="button" class="btn btn-primary" (click)="navService.showLogin()">Login/Sign-Up</button>
  </div>

  <survey *ngIf="!survey.mustBeLoggedIn || auth.isLoggedIn()" [model]="surveyModel"></survey>
  <div *ngIf="!embed" class="text-center">
    <a role="button" [routerLink]="['../../']" *ngIf="surveyModel?.state == 'completed'" class="btn btn-primary">Home</a>
  </div>
</div>
